// extracted by mini-css-extract-plugin
export default {"container":"YjJezvxxHt9Epchq9XTK"};